<div style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">

  @if (payment && !loading) {
    <div style="text-align: center;">
      <svg viewBox="0 0 24 24" style="color: green; width: 5rem" className="text-green-600 w-16 h-16 mx-auto my-6">
        <path fill="currentColor"
          d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z">
        </path>
      </svg>
  
      @if (payment.message === 'Payment completed successfully.') {
      <p>Thank you for completing your secure online payment.</p> }

      <div class="button">
        <lib-button color="primary">
          <a [href]="payment.assessment_url">Take Assessment</a>
        </lib-button>
      </div>
  
      <div>
        <p>Wait until later? You'll get a link in your email. </p>
      </div>

      <lib-content-loader *ngIf="loading"></lib-content-loader>

    </div>
  
  } @else if (!payment && !loading) {
    <div>Failed to process payment. Please try again.</div>
  }

</div>